import React from 'react'
import { func, shape, string, bool } from 'prop-types'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { InquiryTypes } from '../../constants/InquiryTypes'
import { PagesPaths } from '../../constants/Pages'
import { DropdownArrow } from '../ui/buttons/DropdownArrow'
import { InquiryStatus } from '../../constants/InquiryStatus'

export const InquiryListItem = translate()(({ t, request }) => {
  const { date, status, id, type, category, isMaintenance, withVisit, detailedStatus } = request

  const link = (() => {
    // If inquiry is maintenance - but visit - we can display the standard visit details page
    // However - to accept the realisation - we needs to handle a regular payment mean
    if (isMaintenance && type === InquiryTypes.REALISATION) {
      return `${PagesPaths.INQUIRY_MAINTENANCE_DETAIL.path}/${id}`
    }
    switch (type) {
      case InquiryTypes.VISIT:
        return `${PagesPaths.INQUIRY_VISIT_DETAIL.path}/${id}`
      case InquiryTypes.REALISATION:
        return `${PagesPaths.INQUIRY_REALISATION_DETAIL.path}/${id}`
      default:
        return `#`
    }
  })()

  const typeText = (() => {
    if (isMaintenance) {
      return (<p className='request__type request__type--yellow'>{t('common:visits:maintenance')}</p>)
    }
    if (type === InquiryTypes.REALISATION && status !== InquiryStatus.WAITING_QUOTES_ONGOING &&
      category !== InquiryTypes.CREATION && category !== InquiryTypes.ELAGAGE) {
      return (<p className='request__type request__type--blue'>{t('common:visits:ponctual')}</p>)
    }
    if (withVisit) {
      return (<p className='request__type request__type--blue'>{t('common:visits:visit_requested')}</p>)
    }
    if (status === InquiryStatus.WAITING_QUOTES_ONGOING && !withVisit) {
      return (<p className='request__type request__type--blue'>{t('common:visits:visit_ponctual')}</p>)
    }
    if (category === InquiryTypes.CREATION) {
      return (<p className='request__type request__type--blue'>{t('common:visits:creation')}</p>)
    }
    if (category === InquiryTypes.ELAGAGE) {
      return (<p className='request__type request__type--blue'>{t('common:visits:pruning')}</p>)
    }
    return (<p className='request__type request__type--blue'>{t('common:visits:visit')}</p>)
  })()

  return (
    <li className={'request ' + (isMaintenance ? 'request--yellow' : 'request--blue')}>
      <Link className='request__link' to={link}>
        <div>
          <h2 className='request__title'>{t('common:visits:request_of')}{date}</h2>
          { typeText }
          <p>{t('common:visits:status')} : {t('common:visits:statuses:' + detailedStatus)}</p>
        </div>
        <DropdownArrow type='request' color='#000' />
      </Link>
    </li>
  )
})

InquiryListItem.propTypes = {
  t: func,
  request: shape({
    date: string,
    status: string,
    id: string,
    type: string,
    isMaintenance: bool
  })
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryListItem.js